/**
 * Primitive Operations Index
 *
 * Exports all primitive operations and the operation registry.
 */

export * from './arithmetic';
export * from './collections';
export * from './functions';
export * from './logic';
export * from './operations.model';

import { arithmeticOperations } from './arithmetic';
import { collectionOperations } from './collections';
import { functionOperations } from './functions';
import { logicOperations } from './logic';
import { OperationRegistry, PrimitiveOperation } from './operations.model';

// ------------------------------------------------
// ALL OPERATIONS
// ------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const allOperations: Array<PrimitiveOperation<any, any>> = [
  ...arithmeticOperations,
  ...logicOperations,
  ...functionOperations,
  ...collectionOperations,
];

// ------------------------------------------------
// OPERATION REGISTRY
// ------------------------------------------------

/**
 * Registry mapping operation IDs to their definitions.
 * Use this for lookups and tokenizer matching.
 */
export const operationRegistry: OperationRegistry = Object.fromEntries(allOperations.map((op) => [op.id, op]));

/**
 * Get an operation by its ID
 */
export function getOperation(id: string): PrimitiveOperation | undefined {
  return operationRegistry[id];
}

/**
 * Check if an operation ID exists
 */
export function hasOperation(id: string): boolean {
  return id in operationRegistry;
}
